import React from 'react';
import {Box} from 'reactjs-admin-lte';
import FontAwsome from 'react-fontawesome';
import {Col, Row} from 'react-bootstrap';

export default ({loading = true, insurer = {}}) => {
  return (<div>
    <Box loading={loading}>
      <Box.Header>
        <Box.Title border={true}>
          <FontAwsome className="text-blue"
                      name="bank" /> รายละเอียดบริษัทประกัน
        </Box.Title>
      </Box.Header>
      <Box.Body>

        {/*Row 1*/}
        <Row className="form-group">
          <Col sm={2}>
            <label className="control-label">เลือกประกัน</label>
          </Col>
          <Col sm={4}>
            <input className="form-control" disabled
                   value={insurer.insurer_name} />
          </Col>
          <Col sm={2}>
            <label className="control-label">สาขา</label>
          </Col>
          <Col sm={4}>
            <input className="form-control" disabled
                   value={insurer.insurer_branch} />
          </Col>
        </Row>


        {/*Row 2*/}
        <Row className="form-group">
          <Col sm={2}>
            <label className="control-label">หมายเลขกรมธรรม์</label>
          </Col>
          <Col sm={4}>
            <input className="form-control" disabled
                   value={insurer.insurance_policy_no} />
          </Col>
          <Col sm={2}>
            <label className="control-label">ประเภทกรมธรรม์</label>
          </Col>
          <Col sm={4}>
            <input className="form-control" disabled
                   value={insurer.insurance_type} />
          </Col>
        </Row>

        {/*Row 3*/}
        <Row className="form-group">
          <Col sm={2}>
            <label className="control-label">เลขที่เคลม</label>
          </Col>
          <Col sm={4}>
            <input className="form-control" disabled
                   value={insurer.claim_no} />
          </Col>
          <Col sm={2}>
            <label className="control-label">จำนวนเงินคุ้มครอง</label>
          </Col>
          <Col sm={4}>
            <input className="form-control" disabled
                   value={insurer.cover_cost} />
          </Col>
        </Row>

        {/*Row 4*/}
        <Row className="form-group">
          <Col sm={2}>
            <label className="control-label">เลขที่แจ้งอุบัติเหตุ</label>
          </Col>
          <Col sm={4}>
            <input className="form-control" disabled
                   value={insurer.inform_no} />
          </Col>
          <Col sm={2}>
            <label className="control-label">วันที่แจ้งอุบัติเหตุ</label>
          </Col>
          <Col sm={4}>
            <input className="form-control" disabled
                   value={insurer.inform_date} />
          </Col>
        </Row>

        {/*Row 5*/}
        <Row className="form-group">
          <Col sm={2}>
            <label className="control-label">พนักงานเคลม</label>
          </Col>
          <Col sm={4}>
            <input className="form-control" disabled
                   value={''} />
          </Col>
          <Col sm={2}>
            <label className="control-label">วันที่เกิดอุบัติเหตุ</label>
          </Col>
          <Col sm={4}>
            <input className="form-control" disabled
                   value={insurer.accident_date} />
          </Col>
        </Row>


      </Box.Body>
    </Box>
  </div>);
};


// WEBPACK FOOTER //
// ./src/view/workdoc/preview/components/PreviewInsurer.js